import httpManager from "@/app/shared/utils/httpManager";

/**
 * Exportar un contacto a hubspot.
 *
 */
export async function exportContactHubspot(clientId) {
  return await httpManager.post(`/hubspot/clients/export-hubspot/${clientId}/`);
}
